export enum PluginTypes {
  Content = 'Content',
  Products = 'Products',
  Colors = 'Colors',
  Documents = 'Documents',
}
